import { render, staticRenderFns } from "./owner-types.vue?vue&type=template&id=3a6f62b1&"
import script from "./owner-types.vue?vue&type=script&lang=js&"
export * from "./owner-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports